import { useState } from "react";
import { PriorityBadge, DueBadge } from "@/components/TaskMeta";

const COLUMNS = [
  { key: "todo", label: "To Do", dot: "bg-slate-400" },
  { key: "in_progress", label: "In Progress", dot: "bg-amber-500" },
  { key: "done", label: "Done", dot: "bg-emerald-500" },
];

function BoardCard({ t, onOpen }) {
  return (
    <div
      draggable
      onDragStart={(e) => e.dataTransfer.setData("text/plain", t.id)}
      onClick={() => onOpen(t)}
      className={`bg-white border rounded-lg p-3 cursor-grab active:cursor-grabbing hover:shadow-md transition-shadow ${t.unread ? "border-red-300 ring-1 ring-red-200" : "border-slate-200"}`}
      data-testid={`board-card-${t.id}`}
    >
      <div className="flex items-start gap-2">
        {t.unread && <span className="h-2 w-2 mt-1.5 rounded-full bg-red-500 shrink-0" />}
        <p className="text-sm font-medium text-slate-900">{t.title}</p>
      </div>
      <div className="flex flex-wrap items-center gap-1.5 mt-2">
        <PriorityBadge priority={t.priority} />
        <DueBadge due={t.due_date} done={t.status === "done"} />
      </div>
      {t.assignee_name && <p className="text-xs text-slate-400 mt-2">{t.assignee_name}</p>}
    </div>
  );
}

export default function TaskBoard({ tasks, onMove, onOpen }) {
  const [over, setOver] = useState(null);
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="task-board">
      {COLUMNS.map((col) => {
        const items = tasks.filter((t) => t.status === col.key);
        return (
          <div
            key={col.key}
            onDragOver={(e) => { e.preventDefault(); setOver(col.key); }}
            onDragLeave={() => setOver(null)}
            onDrop={(e) => {
              e.preventDefault();
              setOver(null);
              const id = e.dataTransfer.getData("text/plain");
              const t = tasks.find((x) => x.id === id);
              if (t && t.status !== col.key) onMove(id, col.key);
            }}
            className={`rounded-xl border p-3 min-h-[200px] transition-colors ${over === col.key ? "bg-indigo-50 border-indigo-300" : "bg-slate-100/70 border-slate-200"}`}
            data-testid={`board-column-${col.key}`}
          >
            <div className="flex items-center gap-2 mb-3 px-1">
              <span className={`h-2 w-2 rounded-full ${col.dot}`} />
              <p className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-500">{col.label}</p>
              <span className="ml-auto text-xs text-slate-400" data-testid={`board-count-${col.key}`}>{items.length}</span>
            </div>
            <div className="space-y-2">
              {items.map((t) => <BoardCard key={t.id} t={t} onOpen={onOpen} />)}
              {items.length === 0 && <p className="text-xs text-slate-400 px-1 py-6 text-center">Drop tasks here</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
